import { callAllHandlers } from "@smartsheet/lodestar-utils";
import { useState, FocusEventHandler, useMemo } from "react";
interface UseFocusedOptions<ElementType extends HTMLElement> {
    onBlur?: FocusEventHandler<ElementType>;
    onFocus?: FocusEventHandler<ElementType>;
}

export const useFocused = <ElementType extends HTMLElement>({
    onBlur: providedOnBlur,
    onFocus: providedOnFocus,
}: UseFocusedOptions<ElementType>) => {
    const [isFocused, setIsFocused] = useState(false);

    const onFocus: FocusEventHandler<ElementType> = useMemo(
        () =>
            callAllHandlers(providedOnFocus, () => {
                setIsFocused(true);
            }),
        [providedOnFocus]
    );

    const onBlur: FocusEventHandler<ElementType> = useMemo(
        () =>
            callAllHandlers(providedOnBlur, () => {
                setIsFocused(false);
            }),
        [providedOnBlur]
    );

    return {
        isFocused,
        onBlur,
        onFocus,
    };
};
